<div class="sub-menu-root-container user-menu-root-container"
    [style.width]="show ? 'var(--left-side-optionbar-width)' : '25px'">
    <div class="menu-list-container">
        <!-- Masters List -->

        <mat-list-item *ngIf="hasAccess('user-group')" class="mat-list-item" routerLink="/user/user-group"
            [routerLinkActive]="['is-active']" (click)="resetState()" [matTooltip]="!show ? 'Category' : ''"
            matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/user-group.svg">
                <span class="master-title" style="word-wrap: break-word;">User Group
                </span>
            </div>
        </mat-list-item>
        <mat-list-item class="mat-list-item" *ngIf="hasAccess('user')" routerLink="/user/user"
            [routerLinkActive]="['is-active']" [matTooltip]="!show ? 'Employee' : ''" matTooltipPosition="right"
            matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/user.svg">
                <span class="master-title">User
                </span>
            </div>
        </mat-list-item>

        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('custom-menu')" class="mat-list-item"
            routerLink="/user/custom-menu" [routerLinkActive]="['is-active']"
            [matTooltip]="!show ? 'Payroll Group' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/custom-menu.svg">
                <span class="master-title"> Custom Menu
                </span>
            </div>
        </mat-list-item>
        <!-- <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('custom-menu-item')"
                    class="mat-list-item" routerLink="/user/custom-menu-item" [routerLinkActive]="['is-active']"
                    (click)="resetState()" [matTooltip]="!show ? 'Shop Payroll' : ''" matTooltipPosition="right"
                    matTooltipClass="mat-tooltip">
                    <div class="mat-list-item-contents">
                        <img src="assets/images/menu/svg/custom-menu-item.svg">
                        <span class="master-title">Custom Menu Item
                        </span>
                    </div>
                </mat-list-item> -->
        <mat-list-item *ngIf="userData?.user_type === 'HQ' && hasAccess('area-manager-shop')" class="mat-list-item"
            routerLink="/user/area-manager-shop" [routerLinkActive]="['is-active']" (click)="resetState()"
            [matTooltip]="!show ? 'Staff Payroll' : ''" matTooltipPosition="right" matTooltipClass="mat-tooltip">
            <div class="mat-list-item-contents">
                <img src="assets/images/menu/svg/area-manager.svg">
                <span class="master-title">Area Manager

                </span>
            </div>
        </mat-list-item>




    </div>
</div>